<template>
  <div class="filter-chips-context" :class="{ 'is-list': list, 'is-in-use': inUse }">
    <slot />
  </div>
</template>

<script>
// Where a page's filter chips are shown on a phone (PhoneFilterBar): as a list, one line per
// filter, or on the line of the filters in use, where only those show, each with a × that
// clears it. In both, a chip names what it filters ("Statut : Nouveau"), whatever it shows in
// the page's own row.
export default {
  name: 'FilterChipsContext',
  props: {
    list: { type: Boolean, default: false },
    inUse: { type: Boolean, default: false },
  },
  provide() {
    return {
      filterChipsRemovable: this.inUse,
      filterChipsLabelled: this.list || this.inUse,
      filterChipsListed: this.list,
    };
  },
};
</script>

<style lang="scss">
.filter-chips-context {
  display: flex;
  align-items: center;
  gap: 8px;

  // The page's own rows of chips step aside, however deep, and so does a chip's own wrapper (the
  // platforms'): the chips are laid out here, in one line that scrolls or one list.
  > :not(.filter-chip),
  .platform-chip {
    display: contents;
  }

  // Its own rule: a browser without :has() drops only this one.
  :not(.filter-chip):has(.filter-chip) {
    display: contents;
  }

  // One 48px line per filter, its value beside its name and an arrow at the end.
  &.is-list {
    flex-direction: column;
    align-items: stretch;
    gap: 0;

    .filter-chip,
    .filter-chip__btn {
      width: 100%;
    }

    .filter-chip__btn {
      justify-content: flex-start;
      min-height: 48px;
      padding: 0 4px;
      border-bottom: 1px solid $color-border;
      border-radius: 0;
      background: none;
      box-shadow: none;
      font-size: 15px;
      font-weight: 500;
      text-align: left;

      &.is-on {
        outline: none;
        background: none;
      }
    }

    .filter-chip__ico {
      flex: none;
      width: 18px;
      height: 18px;
    }

    .filter-chip__btn .filter-chip__car {
      flex: none;
      width: 18px;
      height: 18px;
      margin-left: auto;
      transform: rotate(-90deg);
    }
  }

  &.is-in-use {
    flex-wrap: nowrap;

    .filter-chip:not(.is-removable) {
      display: none;
    }

    .filter-chip__btn {
      min-height: 36px;
      white-space: nowrap;
    }
  }
}
</style>
